/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type ContractStatus = typeof ContractStatus[keyof typeof ContractStatus];


export const ContractStatus = {
  draft: 'draft',
  in_review: 'in_review',
  out_for_signature: 'out_for_signature',
  executed: 'executed',
  expired: 'expired',
  terminated: 'terminated',
} as const;
